import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Briefcase, Eye, Zap } from 'lucide-react';
import { toast } from 'sonner';

const Statistics = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${backendUrl}/api/admin/stats`, { withCredentials: true });
      setStats(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки статистики');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="text-gray-400">Загрузка...</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card className="bg-gradient-to-br from-blue-900/20 to-blue-900/5 border-blue-800">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-400 flex items-center gap-2">
            <Users className="h-4 w-4" />
            Пользователи
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold text-white">{stats?.total_users || 0}</p>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-br from-green-900/20 to-green-900/5 border-green-800">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-400 flex items-center gap-2">
            <Briefcase className="h-4 w-4" />
            Всего сетапов
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold text-white">{stats?.total_setups || 0}</p>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-br from-purple-900/20 to-purple-900/5 border-purple-800">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-400 flex items-center gap-2">
            <Eye className="h-4 w-4" />
            Публичные сетапы
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold text-white">{stats?.public_setups || 0}</p>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-br from-yellow-900/20 to-yellow-900/5 border-yellow-800">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium text-gray-400 flex items-center gap-2">
            <Zap className="h-4 w-4" />
            Подключений к биржам
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold text-white">{stats?.exchange_connections || 0}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Statistics;